@if (membershipOrigin(); as membershipOrigin) {
  <markant-platform-ui-card [headline]="'user.details.membership' | transloco">
    <markant-platform-ui-card-item
      [title]="pathOriginatedTitle() | transloco"
      [label]="pathOriginatedTitle() | transloco"
    >
      <span>
        {{
          pathOriginatedItem()
            | transloco
              : {
                  name: membershipOrigin.createdByFullName,
                  date:
                    membershipOrigin.createdAt
                    | translocoDate
                    | defaultValue: 'common.notKnown'
                    | transloco,
                  isInactive:
                    membershipOrigin.createdByIsActiveInOrganization === false
                      ? '(' + ('common.inactive' | transloco) + ')'
                      : '',
                }
        }}
      </span>
    </markant-platform-ui-card-item>

    <markant-platform-ui-card-item
      [label]="'user.details.activationDate' | transloco"
      [title]="'user.details.activationDate' | transloco"
    >
      <span>
        {{
          membershipOrigin.becameActiveAt ?? ''
            | translocoDate
            | defaultValue: 'common.notKnown'
            | transloco
        }}
      </span>
    </markant-platform-ui-card-item>
  </markant-platform-ui-card>
}
